export default {
    format_sd_card_title: "Format SD Card",
    format_sd_card_command_sent_to_the_device: "Command sent to the device",
    format_sd_card_error_sending_the_command: "Error sending the command",
    format_sd_card_label: "Do you want to format the SD card for this device?",
    format_sd_card_format_sd_card: "Format SD Card",
}